import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

interface DeleteConfirmationProps {
    children: JSX.Element;
    handleCancel: () => void;
    handleConfirmation: () => void;
    removing: boolean;
    show: boolean;
}
export function DeleteConfirmation({
    children,
    handleCancel,
    handleConfirmation,
    removing,
    show,
}: DeleteConfirmationProps) {
    return (
        show && (
            <div className="text-center mb-3">
                <p>{children}</p>
                <div>
                    <Button className="btn btn-secondary me-4" type="button" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button
                        className="btn btn-danger"
                        type="button"
                        onClick={handleConfirmation}
                        disabled={removing}
                    >
                        {removing && (
                            <Spinner animation="border" role="status" size="sm" className="me-1" />
                        )}
                        Yes, Delete
                    </Button>
                </div>
            </div>
        )
    );
}
